export default __webpack_public_path__ + "static/media/isabela-nunes.9e384355.jpg";